import { createFileRoute, redirect } from '@tanstack/react-router';
import { bidComplianceQuery } from '@/features/bid-compliance/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/',
)({
  staticData: { chatSurface: 'bid_compliance' },
  beforeLoad: async ({ context, params }) => {
    const { projectId, workspaceId, bidId } = params;
    const compliance = await context.queryClient.query({
      ...bidComplianceQuery(workspaceId, bidId),
      staleTime: 'static',
    });
    const categoryId = compliance.sections[0]?.category;
    if (!categoryId)
      throw redirect({
        to: '/project/$projectId/workspaces/$workspaceId/bids/$bidId',
        params: { projectId, workspaceId, bidId },
        search: { tab: 'compliance' },
        replace: true,
      });
    throw redirect({
      to: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId',
      params: { projectId, workspaceId, bidId, categoryId },
      search: { tab: 'compliance' },
      replace: true,
    });
  },
});
